import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Confetti from "../Confetti";
import { TREASURES } from "../../data/story";
import { shuffle } from "../../data/phonicsContent";
import { sfx } from "../../services/soundfx";
import { speak } from "../../services/phonicsAudio";

export default function RewardPick({ stars, onPick }) {
  const [choices] = useState(() => shuffle(TREASURES).slice(0, 3));
  const [chosen, setChosen] = useState(null);

  useEffect(() => {
    sfx.fanfare();
    const t = setTimeout(() => speak("You found treasure! Pick one to keep!"), 500);
    return () => clearTimeout(t);
  }, []);

  const choose = (t) => {
    if (chosen) return;
    setChosen(t);
    sfx.star();
    speak(`You got a ${t.name}!`);
    setTimeout(() => onPick(t), 1400);
  };

  return (
    <div className="fixed inset-0 z-[95] flex items-center justify-center p-4 no-select" style={{ background: "#0F172ACC", backdropFilter: "blur(8px)" }} data-testid="reward-pick">
      <Confetti show count={70} />
      <motion.div initial={{ scale: 0.7, opacity: 0, y: 30 }} animate={{ scale: 1, opacity: 1, y: 0 }} transition={{ type: "spring", stiffness: 220, damping: 16 }} className="w-full max-w-md rounded-[2rem] bg-white border-[6px] border-amber-300 shadow-2xl p-6 text-center">
        <div className="flex items-center justify-center gap-1 mb-2">
          {[1, 2, 3].map((n) => (
            <span key={n} className="text-3xl" style={{ filter: n <= stars ? "none" : "grayscale(1) opacity(0.4)" }}>⭐</span>
          ))}
        </div>
        <h2 className="font-display text-3xl font-black text-amber-500 mb-1">Treasure!</h2>
        <p className="font-bold text-slate-500 mb-5">Pick one to keep forever</p>
        <div className="grid grid-cols-3 gap-3">
          {choices.map((t) => (
            <motion.button
              key={t.id}
              data-testid={`reward-${t.id}`}
              onClick={() => choose(t)}
              animate={chosen && chosen.id === t.id ? { scale: [1, 1.3, 1.1], rotate: [0, -10, 10, 0] } : chosen ? { opacity: 0.3, scale: 0.9 } : { y: [0, -6, 0] }}
              transition={chosen ? { duration: 0.6 } : { repeat: Infinity, duration: 1.8 }}
              className="pop-btn flex flex-col items-center gap-1 rounded-2xl bg-amber-50 border-4 border-amber-200 shadow-[0_5px_0_#FBBF24] active:shadow-none py-5"
            >
              <span className="text-5xl">{t.emoji}</span>
              <span className="text-[11px] font-bold text-amber-700">{t.name}</span>
            </motion.button>
          ))}
        </div>
      </motion.div>
    </div>
  );
}
